import type { AuthUser } from '@/modules/auth/constants/auth.schemas'

export interface AuthUserDisplay {
  cpf: string
  email: string
  initials: string
  name: string
  phone: string
}

export function toAuthUserDisplay(user: AuthUser | null): AuthUserDisplay {
  return {
    cpf: user?.cpf ?? '',
    email: user?.email ?? '',
    initials: user?.initials ?? 'PQ',
    name: user?.name ?? '',
    phone: user?.phone ?? '',
  }
}

export function displayOrMissing(value: string): string {
  return value.trim() || 'Não informado'
}
